import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-style-guide';
import navigationUtil from '../util/navigationUtil';

const { isLoginLinkAvailable, getLoginLinkUrl } = navigationUtil;
const handleLoginClick = () => {
  window.location.href = getLoginLinkUrl();
};

function HeaderLoginLink({ translate }) {
  return (
    <li className='login-action'>
      {isLoginLinkAvailable() && (
        <span>
          <Link
            onClick={handleLoginClick}
            url={getLoginLinkUrl()}
            className='font-header-2 rbx-navbar-login nav-menu-title rbx-menu-item'>
            {translate('Label.sLogin')}
          </Link>
        </span>
      )}
    </li>
  );
}
HeaderLoginLink.propTypes = {
  translate: PropTypes.func.isRequired
};

export default HeaderLoginLink;
